export const PAYMENT_TYPE = {
  FLEX_PAY: 'flexpay',
  PAY_IN_FULL: 'upfront',
};
